/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
    super()

    this.els = {
      products: this.querySelector('[data-product-recommendations-el="products"]'),
    }

    this.state = {
      limit: Number(this.dataset.limit),
      productIds: this.dataset.productIds,
      recommendationId: this.dataset.recommendationId
    }
  }

	connectedCallback () {
    onTagalysReady(() => {
      this.fetchRecommendations()
    })
  }

  fetchRecommendations () {
    const productIds = (this.state.productIds || '')
      .split(',')
      .map(id => id.trim())
      .filter(Boolean)

    if (!productIds.length || !this.els.products) return

    const params = {
      recommendationId: this.state.recommendationId,
      productIds,
      count: this.state.limit
    }

    window.Tagalys.APIConnector.Recommendations.call({
      params: params,
      onSuccess: response => {
        const products = Array.isArray(response?.products) ? response.products : []

        if (products.length === 0) {
          this.fetchShopifyRecommendations()

          return
        }

        const handles = products.map(product => product.handle).filter(Boolean)

        return this.renderProductCards(handles)
      },
      onFailure: response => {
        console.error('Failed to fetch recommendations', response)

        this.fetchShopifyRecommendations()
      }
    })
  }

  async fetchShopifyRecommendations () {
    try {
      const productId = (this.state.productIds || '').split(',')[0]?.trim()

      if (!productId || !this.els.products) return

      const response = await fetch(`${Shopify.routes.root}recommendations/products.json?product_id=${encodeURIComponent(productId)}&intent=related`)

      if (!response.ok) throw new Error(`Request failed with status ${response.status}`)

      const { products } = await response.json()
      const handles = (Array.isArray(products) ? products : [])
        .map(product => product.handle)
        .filter(Boolean)

      return this.renderProductCards(handles)
    } catch (error) {
      console.error('Failed to fetch Shopify recommendations', error)

      return
    }
  }

  async getProductCards (handles) {
    const productCardNodes = await Promise.all(
      handles.map(async handle => {
        try {
          const productCardHTML = await this.getProductCardHTML(handle)

          const template = document.createElement('template')
          template.innerHTML = productCardHTML.trim()

          const productCardEl = template.content.querySelector('.shopify-section')

          if (!productCardEl) return false

          return productCardEl.innerHTML
        } catch (error) {
          console.error(`Failed to fetch product card for ${handle}`, error)

          return false
        }
      }),
    )

    return productCardNodes
  }

  async renderProductCards (handles) {
    if (!handles.length || !this.els.products) return

    const first4Handles = handles.slice(0, 4)
    const productCardNodes = await this.getProductCards(first4Handles)
    const validNodes = productCardNodes.filter(Boolean)

    const fragment = document.createDocumentFragment()
    validNodes.forEach(htmlString => {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      fragment.appendChild(tempDiv.firstElementChild)
    })

    this.els.products.appendChild(fragment)

		this.classList.add('product-recommendations--full')

		if (document.body.classList.contains('open-cart')) {
			this.classList.add('active')
		}

		this.classList.add('product-recommendations--loaded')
  }

  async getProductCardHTML (handle) {
    const response = await fetch(`${Shopify.routes.root}products/${handle}/?section_id=product-card-small`)

    if (!response.ok) throw new Error(`Request failed with status ${response.status}`)

    const section = await response.text()

    return section
  }
}

customElements.define('product-recommendations', ProductRecommendations)
